<template>
    <!-- <router-view v-if="!$store.state.loginData.checkingForLogin" /> -->
    <router-view />
</template>

<script>
import $ from "jquery";
window.$ = $
import Cookies from 'js-cookie'
window.Cookies = Cookies
import device from 'current-device'
window.device = device

import vueAPI from "./modules/vueAPI.js"

import Trans from '@/plugins/Translation.js'

window.unregSW = function() {
    vueAPI.onServiceWorkerInstalled((serviceWorker) => {
        serviceWorker.unregister().then(() => {
            console.log('Service worker unregistered')
            location.reload()
        })
    })
}


var hasWebP = (function() {
    var images = {
        basic: "data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoCAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==",
        lossless: "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="
    };
    
    return function(feature) {
        var deferred = $.Deferred();
        
        $("<img>").on("load", function() {
            if(this.width === 2 && this.height === 1) {
                deferred.resolve();
            } else {
                deferred.reject();
            }
        }).on("error", function() {
            deferred.reject();
        }).attr("src", images[feature || "basic"]);
        
        return deferred.promise();
    }
})();

function hasObserver() {
    return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}

export default {
    name: 'App',
    mounted() {
        vueAPI._mountedCallback(this)
    },
    beforeMount() {
        hasWebP().then(() => {
            console.log("WebP supported");
            this.$store.state.globalData.webpSupport.support = true
        }, function() {
            console.log("WebP not supported");
        });
        hasWebP('lossless').then(() => {
            console.log("WebP lossless supported");
            this.$store.state.globalData.webpSupport.loseless = true
        }, function() {
            console.log("WebP lossless not supported");
        });

        if (hasObserver()) {
            this.$store.state.globalData.hasObserver = true
        }

        if (localStorage.getItem('lang')) {
            Trans.changeLocale(localStorage.getItem('lang'))
        }
    },
    watch: {
        '$i18n.locale': function(newValue) {
            this.setLocalStorageLanguage(newValue)
        },
        '$store.getters.getLoginState': function(newValue) {
            if (newValue == true) return

            console.log(`Login state changed to ${newValue}`)
            console.log(this.$route.meta.requiresAuth)

            if (this.$route.meta.requiresAuth) {
                this.$store.state.loginData.unloginPosition = window.location.pathname
                this.$router.replace('/login')
            }
        }
    },
    methods: {
        setLocalStorageLanguage(lang = false) {
            if (lang) {
                localStorage.setItem('lang', lang)
            } else {
                localStorage.setItem('lang', this.$i18n.locale)
            }
        }
    },
}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
        color: #42b983;
        }
    }
}

@import "/src/vendor/bootstrap/css/bootstrap.css";
@import "/src/styles/scss/util.scss";
@import "/src/styles/scss/main.scss";
@import "/src/styles/scss/admin.scss";
</style>
